var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "#fff",
  "aria-hidden": "true",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.667 13.607a.333.333 0 1 0 .666 0V5.056a.333.333 0 1 0-.666 0zM10.468 13.94h-.023a.334.334 0 0 1-.31-.355l.568-8.551a.34.34 0 0 1 .355-.311.334.334 0 0 1 .31.355l-.569 8.551a.333.333 0 0 1-.332.312M5.2 13.63a.333.333 0 0 0 .333.31h.022a.334.334 0 0 0 .31-.355l-.568-8.551a.334.334 0 0 0-.665.044z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m9.801.891.586 1.796H15.2a.333.333 0 1 1 0 .667h-1.053l-.896 12.363a.334.334 0 0 1-.332.31h-9.85a.333.333 0 0 1-.332-.31L1.84 3.354H.787a.333.333 0 1 1 0-.667H5.6L6.185.89a.33.33 0 0 1 .317-.23h2.981c.145 0 .272.093.317.23m-.559.437.443 1.359H6.301l.444-1.359zM12.61 15.36h-9.23l-.87-12.005h10.97z",
  clipRule: "evenodd"
})));
export default SvgTrash;